import { z } from 'zod';
import { customBoolDict, stringAsBool } from '../../utils';

export const customBooleanValidator = z
  .string()
  .refine(value => customBoolDict[value.toLowerCase()] != undefined)
  .transform(value => stringAsBool(value.toLowerCase(), true, true, customBoolDict));
